import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_WORKER_REPORT_EXCEL_REQUEST = 'DOWNLOAD_WORKER_REPORT_EXCEL_REQUEST';
export const DOWNLOAD_WORKER_REPORT_EXCEL_SUCCESS = 'DOWNLOAD_WORKER_REPORT_EXCEL_SUCCESS';
export const DOWNLOAD_WORKER_REPORT_EXCEL_FAILURE = 'DOWNLOAD_WORKER_REPORT_EXCEL_FAILURE';

export type WorkerReportExcelState = DefaultState;

interface WorkerReportExcelRequest {
  type: typeof DOWNLOAD_WORKER_REPORT_EXCEL_REQUEST;
};

interface WorkerReportExcelSuccess {
  type: typeof DOWNLOAD_WORKER_REPORT_EXCEL_SUCCESS,
}

interface WorkerReportExcelFailure {
  type: typeof DOWNLOAD_WORKER_REPORT_EXCEL_FAILURE;
}

export type WorkerReportExcelActionTypes = WorkerReportExcelRequest | WorkerReportExcelSuccess | WorkerReportExcelFailure;